// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC.

export const DATEFORMATSTRING = 'YYYY/MM/DD'
export const ENDPOINT = 'api/'

export const FORMFIELDTYPE = {
  DATE: 'date',
  HEADER: 'header',
  RADIO: 'radio',
  TEXTBOX: 'textbox',
  TEXTDISPLAY: 'textdisplay',
  TEXTINPUT: 'textinput'
}

export const EXCEPTIONTYPES = {
  zoneTimeExceptions: 'zoneTimeException',
  invThingsMissing: 'inventoryThingsMissing',
  invThingsUnexpected: 'inventoryThingsUnexpected'
}



// WEBPACK FOOTER //
// ./src/shared/constants.js